import Vue from 'vue'
import FreightTransformer from '@/transformers/purchase/freight'
import moment from "moment";

function urlParamsTransformer({
  deliveryDate,
  provider,
  revi,
  asc,
  searchQuery: text,
  page,
  pageSize,
  warehouseId,
}) {
  let params = {
    page,
    size: pageSize,
    iwarehouse: warehouseId > 0 ? warehouseId : undefined,
    ascending_order: asc ? true : undefined,
    revi: revi ? revi : undefined,
    provider: provider ? provider : undefined,
    date: deliveryDate
      ? moment(deliveryDate).format("YYYY/MM/DD")
      : undefined,
    text,
  };

  if (!text) {
    delete params.text;
  }
  return params;
}

export default (fetchOptions) => {
  const params = fetchOptions ? urlParamsTransformer(fetchOptions) : null;
  return Vue.$http
    .get('purchase/list_freight_orders/', { params })
    .then((response) => {
      const data = FreightTransformer.fetchCollection(response.data)
      return data
    })
    .catch((error) => {
      const response = error.response
      if (response && response.status !== 404) {
        throw error
      }
    })
}


// WEBPACK FOOTER //
// ./src/services/purchase/fetchFreight.js